module.exports = __webpack_public_path__ + "assets/img/windows-2.19dbcb4a.jpg";